import styled from 'styled-components';

const CategoryFilter = styled.div`
height:280px;
overflow:auto;
margin-top:20px;
color:#000;
//   @media only screen and (max-width: 1200px) {
//     // width: 100%;
//     margin-left: 0px !important;
//     margin-right: 0px !important;

//   }
`;

export default CategoryFilter;